var _circle, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_84)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2114 36.0204C27.4918 41.3864 23.1694 44.2804 23.0654 44.8212C22.7028 46.7081 22.917 46.7236 49.818 46.7236C72.127 46.7236 75.3294 46.6448 76.1477 46.0748C76.6604 45.7182 77.0796 45.0307 77.0796 44.5474C77.0796 44.0637 76.9592 43.7875 76.8125 43.9337C76.6654 44.0795 76.0525 43.8566 75.4501 43.4383C72.1861 41.1718 50.2314 27.9784 49.7593 28C49.4529 28.0142 43.3564 31.6232 36.2114 36.0204ZM47.7518 37.7457C46.9829 38.6661 47.4017 39.7856 48.6824 40.2331C50.9721 41.0335 53.2136 39.3065 51.9103 37.7457C51.2568 36.9629 48.4053 36.9629 47.7518 37.7457ZM23.0679 45.057C23.0679 45.6299 23.1631 45.8644 23.2792 45.5778C23.3958 45.2915 23.3958 44.8228 23.2792 44.5362C23.1631 44.2499 23.0679 44.4841 23.0679 45.057Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2564 65.5683C22.807 66.7324 22.9852 70.9755 23.505 71.4921C23.8852 71.87 30.3096 71.9921 49.8501 71.9921C79.6089 71.9921 77.0798 72.3746 77.0798 67.8723C77.0798 66.2479 76.923 65.3729 76.6606 65.5341C76.43 65.6758 76.2414 65.5929 76.2414 65.3504C76.2414 65.0446 68.1532 64.9092 49.8761 64.9092C26.2211 64.9092 23.4849 64.9771 23.2564 65.5683ZM23.1395 68.4506C23.1415 70.0547 23.217 70.6597 23.308 69.7956C23.3985 68.931 23.3973 67.6186 23.3046 66.8791C23.212 66.1391 23.1378 66.8466 23.1395 68.4506Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_84)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2808 55.8872V66.5498H29.8486H33.4165V55.8872V45.2246H29.8486H26.2808V55.8872ZM39.6008 55.8872V66.5498H43.1687H46.7365V55.8872V45.2246H43.1687H39.6008V55.8872ZM53.3966 55.8872V66.5498H56.9644H60.5323V55.8872V45.2246H56.9644H53.3966V55.8872ZM66.7166 55.8872V66.5498H70.2845H73.8524V55.8872V45.2246H70.2845H66.7166V55.8872Z",
    fill: "url(#paint1_linear_1062_84)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2808 55.8872V66.5498H29.8486H33.4165V55.8872V45.2246H29.8486H26.2808V55.8872ZM39.6008 55.8872V66.5498H43.1687H46.7365V55.8872V45.2246H43.1687H39.6008V55.8872ZM53.3966 55.8872V66.5498H56.9644H60.5323V55.8872V45.2246H56.9644H53.3966V55.8872ZM66.7166 55.8872V66.5498H70.2845H73.8524V55.8872V45.2246H70.2845H66.7166V55.8872Z",
    stroke: "url(#paint2_linear_1062_84)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_84",
    x: 24.1308,
    y: 43.0746,
    width: 51.8718,
    height: 25.6252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_84",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_84",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_84",
    x1: 31.3714,
    y1: 47.1921,
    x2: 59.2673,
    y2: 79.4136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_84",
    x1: 54.0309,
    y1: 48.7788,
    x2: 58.1231,
    y2: 70.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovBuilding);
export default __webpack_public_path__ + "static/media/gov-building.b8158caf324c7e7c867d79b8e9c466ca.svg";
export { ForwardRef as ReactComponent };